const {
  FETCH_DETAILED_USAGES,
  FETCH_DETAILED_USAGES_SUCCESS,
  FETCH_USAGE_AGGREGATE,
  FETCH_USAGE_AGGREGATE_SUCCESS,
  FETCH_USAGES,
  FETCH_USAGES_SUCCESS,
  FETCH_USAGES_FAILURE,
  REDIRECT_AFTER_USAGE_FRAME_ON_TITLE_PRESS,
  RESET_USAGE,
  UPDATE_USAGE_DISPLAY_MODE,
} = require('../../lib/constants').default;

export type UsagesActionType =
  | {|
      type: 'FETCH_DETAILED_USAGES',
      payload: {| subscriptionOuid: string, beginDate: number, endDate: number |},
    |}
  | {|
      type: 'FETCH_DETAILED_USAGES_SUCCESS',
      payload: {| detailedUsages: Object[] |},
    |}
  | {|
      type: 'FETCH_USAGE_AGGREGATE',
      payload: {| subscriptionOuid: string, period: string, beginDate: number, endDate: number |},
    |}
  | {|
      type: 'FETCH_USAGE_AGGREGATE_SUCCESS',
      payload: {| usageAggregate: Object[] |},
    |}
  | {|
      type: 'FETCH_USAGES',
      payload: {| line: string |},
    |}
  | {|
      type: 'FETCH_USAGES_SUCCESS',
      payload: {| usages: Object[] |},
    |}
  | {|
      type: 'FETCH_USAGES_FAILURE',
      error: any,
    |}
  | {|
      type: 'REDIRECT_AFTER_USAGE_FRAME_ON_TITLE_PRESS',
    |}
  | {|
      type: 'RESET_USAGE',
    |}
  | {|
      type: 'UPDATE_USAGE_DISPLAY_MODE',
      payload: {| mode: string |},
    |};

export const fetchDetailedUsagesSuccess = (detailedUsages): UsagesActionType => ({
  type: FETCH_DETAILED_USAGES_SUCCESS,
  payload: { detailedUsages },
});

export const fetchUsageAggregateSuccess = (usageAggregate): UsagesActionType => ({
  type: FETCH_USAGE_AGGREGATE_SUCCESS,
  payload: { usageAggregate },
});

export const fetchDetailedUsages = (
  subscriptionOuid: string,
  beginDate: number,
  endDate: number
): UsagesActionType => ({
  type: FETCH_DETAILED_USAGES,
  payload: { subscriptionOuid, beginDate, endDate },
});

export const fetchUsageAggregate = (
  subscriptionOuid: string,
  period: string,
  beginDate: number,
  endDate: number
): UsagesActionType => ({
  type: FETCH_USAGE_AGGREGATE,
  payload: { subscriptionOuid, period, beginDate, endDate },
});

export const redirectAfterUsageFrameOnTitlePress = (): UsagesActionType => ({
  type: REDIRECT_AFTER_USAGE_FRAME_ON_TITLE_PRESS,
});

export const resetUsage = (): UsagesActionType => ({
  type: RESET_USAGE,
});

export const fetchUsages = (line: string): UsagesActionType => ({
  type: FETCH_USAGES,
  payload: { line },
});

export const fetchUsagesSuccess = (usages: Object[]): UsagesActionType => ({
  type: FETCH_USAGES_SUCCESS,
  payload: { usages },
});

export const clearUsages = (): UsagesActionType => fetchUsagesSuccess([]);

export const fetchUsagesFailure = (error: any): UsagesActionType => ({
  type: FETCH_USAGES_FAILURE,
  error,
});

export const updateUsageDisplayMode = mode => ({
  type: UPDATE_USAGE_DISPLAY_MODE,
  payload: { mode },
});
